import React, { useState, useEffect } from 'react';
import '../components/styles/FAQPage.css';

const faqData = [
    {
        category: "서비스 기능",
        color: "#FF5FBF",
        questions: [
            "소프트캣은 어떤 서비스를 제공하나요?",
            "PC와 모바일에서도 사용이 가능한가요?",
            "실시간 제어가 가능한가요?",
            "내가 원하는 기능을 추가할 수도 있나요?",
            "운영 중 네트워크 차단이나 프로그램 충돌로 문제 발생할 가능성이 있나요?"
        ],
        answers: [
            "소프트캣은 PC에서 사용할 수 있는 자동화 프로그램으로, 다양한 기능을 제공합니다. 예를 들어, 반복적인 작업을 자동으로 수행하거나, 특정 조건에 따라 작업을 실행하는 등의 기능이 있습니다. 반복적인 작업을 자동화 하여 시간과 비용을 절감하고 싶은 분들께 추천합니다.",
            "소프트캣 프로그램은 PC(Windows) 환경에서 사용이 가능합니다.",
            "네, 소프트캣은 실시간으로 제어가 가능합니다. 사용자는 언제든지 프로그램의 동작을 중지하거나 변경할 수 있습니다.",
            "네, 사용자가 원하는 기능을 추가할 수 있습니다. 소프트캣은 사용자 정의가 가능한 구조로 설계되어 있어, 필요에 따라 기능을 확장할 수 있습니다. 단, 별도의 맞춤형 상품 신청이 필요합니다.",
            "네, 운영 중 네트워크 차단이나 프로그램 충돌로 인해 문제가 발생할 가능성이 있습니다. 따라서 사용자는 주기적으로 프로그램을 업데이트하고, 문제가 발생했을 때는 즉시 지원팀에 문의해야 합니다. 정상적인 사용 시 차단 위험이 낮지만, 과도한 활동 시 네이버, 구글 등의 보안 시스템이 감지하여 차단할 수 있습니다."
        ]
    },
    {
        category: "사용방법",
        color: "#379F1D",
        questions: [
            "프로그램 설치는 어떻게 하나요?",
            "사용법이 어려운가요? 초보자도 쉽게 사용할 수 있나요?",
            "설치 후 실행되지 않거나 오류가 발생하면 어떻게 해야 하나요?",
            "정상적으로 실행되려면 네이버, 구글 등 계정 로그인이 필요한가요?"
        ],
        answers: [
            "소프트캣 프로그램은 '마이페이지 > 구매항목의 다운로드 버튼 클릭'으로 설치가 가능합니다. 설치 후 사용자의 PC에 자동으로 설치됩니다. 설치 후 사용자는 설치된 프로그램을 실행하여 사용할 수 있습니다. 추후 '마이페이지 > 구매항목의 키 보기 클릭 > 키 활성화'를 통해 프로그램을 활성화할 수 있습니다.",
            "소프트캣은 사용자 친화적인 인터페이스를 제공하여 초보자도 쉽게 사용할 수 있도록 설계되었습니다. 사용법에 대한 자세한 가이드는 소프트캣 공식 웹사이트(동영상 매뉴얼 또는 해당 상품 상세페이지의 영상)나 고객센터에서 확인할 수 있습니다.",
            "소프트캣 프로그램의 설치가 완료되었는지 확인하려면 프로그램을 실행하면 됩니다. 프로그램이 실행되지 않거나 오류가 발생하면, 소프트캣 고객센터에 문의해주세요.",
            "일부 프로그램의 경우, 계정 로그인이 필요한 경우가 있습니다. 예를 들어, 네이버, 구글 등의 계정 로그인이 필요한 프로그램은 해당 계정으로 로그인 후 사용해야 합니다. 하지만 프로그램 자체는 계정 로그인이 필요하지 않습니다."
        ]
    },
    {
        category: "구매 및 라이선스",
        color: "#388AF5",
        questions: [
            "구매 후 다른 컴퓨터에서도 사용할 수 있나요?",
            "라이선스 인증 방식은 어떻게 되나요?"
        ],
        answers: [
            "소프트캣은 구매 후 다른 컴퓨터에서도 사용할 수 있습니다. 단, 라이선스 인증이 필요하며, 라이선스는 구매한 계정에 연결되어 있습니다. 발급된 해시키 한개당 2대의 PC에서만 사용이 가능합니다. 2대를 이미 등록한 상태에서 다른 PC에서 사용을 원하실 경우, 기존 PC에서 인증을 해제한 후 새로운 PC에서 인증을 받아야 하므로 고객센터에 문의해주세요.",
            "소프트캣의 라이선스 인증 방식은 온라인 인증 방식입니다. 프로그램을 실행하기전, 홈페이지 로그인 후 키 확인('마이페이지 > 구매항목의 키 보기 클릭 > 키 활성화')을 통해 키를 확인하고, 키를 활성화하면 소프트캣 프로그램 통해 라이선스를 인증받아야 하며, 인증이 완료되면 프로그램을 사용할 수 있습니다."
        ]
    },
    {
        category: "환불 및 A/S",
        color: "#9967E0",
        questions: [
            "구매 후 환불이 가능한가요?",
            "A/S 및 기술 지원은 어떻게 받을 수 있나요?"
        ],
        answers: [
            "소프트캣은 구매 후 7일 이내에 환불이 가능합니다. 단, 프로그램 사용이 시작되면 단순변심으로 인한 환불이 불가능합니다. 환불을 원하시면 고객센터에 문의해주세요. 오류로 인한 환불일 경우, 7일 이후에도 사용일수를 제외한 나머지 기간에 대해 환불이 가능합니다.",
            "A/S 및 기술 지원은 소프트캣 고객센터를 통해 받을 수 있습니다. 고객센터는 이메일, 카카오톡, 전화, 원격지원 등 다양한 방법으로 운영됩니다. (고객센터 운영시간 : 평일 09:00 ~ 18:00, 점심시간 12:00 ~ 13:00 제외) 또한, 프로그램 사용법 관련 설명 영상도 제공되며, 고객센터를 통해 추가적인 지원을 받을 수 있습니다."
        ]
    },
    {
        category: "법적 문제 및 안전성",
        color: "#FF6D38",
        questions: [
            "이 프로그램은 사용이 불법인가요?",
            "이 프로그램을 사용하면 내 계정이 정지될 위험이 있나요?",
            "네이버, 구글 등 플랫폼 운영 정책에 위반되지 않나요?",
            "보안 문제는 없나요? (개인정보 유출 위험 여부)",
            "바이러스나 악성코드 감염 위험이 있나요?"
        ],
        answers: [
            "아니오, 정상적인 범위 내에서 사용 시 불법이 아닙니다. 소프트캣 프로그램은 사용자가 반복적인 작업을 자동화하여 효율성을 높이는 도구로, 합법적인 용도로 사용됩니다. 단, 각 플랫폼의 이용약관을 준수해야 합니다.",
            "소프트캣 프로그램은 정상적인 범위 내에서 사용 시 계정 정지 위험이 거의 없습니다. 그러나 과도한 활동이나 비정상적인 사용은 계정 정지의 원인이 될 수 있으므로, 각 플랫폼의 이용약관을 준수해야 합니다.",
            "네이버, 구글 등의 API 및 운영 정책을 준수하는 방식으로 개발되어 있습니다. 따라서 정상적인 범위 내에서 사용 시 플랫폼 운영 정책에 위반되지 않습니다. 단, 각 플랫폼의 이용약관을 준수해야 합니다.",
            "네, 소프트캣 프로그램이 직접 개인정보를 수집하거나 저장하지 않습니다. 또한, 외부로 데이터를 전송하지 않습니다. 즉, 사용자의 개인정보는 소프트캣 서버에 저장되지 않으며, 프로그램 사용 중 발생할 수 있는 보안 문제에 대해서는 고객센터를 통해 지원을 받을 수 있습니다.",
            "소프트캣 프로그램은 바이러스나 악성코드 감염 위험이 없습니다. 소프트캣은 신뢰할 수 있는 소스에서 다운로드 및 설치되며, 정기적으로 업데이트되어 보안 취약점을 최소화합니다. 그러나 사용자는 항상 최신 버전을 유지하고, 신뢰할 수 있는 출처에서만 프로그램을 다운로드해야 합니다."
        ]
    },
    {
        category: "유지보수 및 추가기능",
        color: "#349FBD",
        questions: [
            "정기적인 업데이트가 제공되나요?",
            "사용 중 추가 기능 요청이 가능한가요?"
        ],
        answers: [
            "네, 소프트캣은 정기적으로 업데이트가 제공됩니다. 사용중인 플랫폼에서의 정책 변경, 또는 프로그램 오류 발생시 신속하게 업데이트를 제공합니다. 사용자는 프로그램을 재 실행하기만 하면, 자동으로 최신 버전으로 업데이트됩니다.",
            "네, 사용자는 추가 기능 요청을 통해 프로그램의 기능을 확장할 수 있습니다. 추가 기능 요청은 소프트캣 공식 웹사이트의 맞춤상품 신청 페이지를 통해 요청할 수 있습니다. 단, 추가 기능은 별도의 비용이 발생할 수 있습니다."
        ]
    },
    {
        category: "고객지원",
        color: "#FF697D",
        questions: [
            "고객 지원은 어떻게 받을 수 있나요? (이메일, 카카오톡, 전화 등)",
            "기술 지원은 무료인가요?",
            "고객 지원 운영 시간은 언제인가요?",
            "원격 지원이 가능한가요?",
            "프로그램 사용법 관련 설명 영상이 제공되나요?"
        ],
        answers: [
            "소프트캣 고객센터는 이메일, 카카오톡, 전화 등 다양한 방법으로 운영됩니다. 고객센터는 소프트캣 공식 웹사이트에서 확인할 수 있습니다.",
            "네, 소프트캣의 기술 지원은 무료입니다. 사용자는 프로그램 사용 중 발생하는 문제에 대해 고객센터를 통해 지원을 받을 수 있습니다.",
            "고객 지원 운영 시간은 평일 09:00 ~ 18:00이며, 점심시간(12:00 ~ 13:00)에는 운영되지 않습니다.",
            "네, 소프트캣은 원격 지원을 제공합니다. 고객센터를 통해 원격 지원을 요청할 수 있으며, 이를 통해 프로그램 설치나 설정 관련 문제를 해결할 수 있습니다.",
            "네, 소프트캣은 프로그램 사용법 관련 설명 영상을 제공합니다. 소프트캣 공식 웹사이트(동영상 매뉴얼 또는 각 상품의 상세페이지)나 유튜브 채널에서 확인할 수 있습니다."
        ]
    }
];

const FAQPage = () => {
    const [openIndex, setOpenIndex] = useState(null);
    const [selectedCategory, setSelectedCategory] = useState("전체");

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    const toggleQuestion = (index) => {
        setOpenIndex(openIndex === index ? null : index);
    };

    const filteredFaqs = selectedCategory === "전체"
        ? faqData
        : faqData.filter(faq => faq.category === selectedCategory);

    return (
        <div className="faq-wrapper">
            <div className="faq-header">
                <h1>자주 묻는 질문</h1>
                <p>소프트캣에서 자주 질문되는 내용이에요</p>
            </div>

            <div className="faq-filters">
                <button
                    className={`filter ${selectedCategory === "전체" ? "active" : ""}`}
                    onClick={() => setSelectedCategory("전체")}
                >
                    전체
                </button>
                {faqData.map((sec, i) => (
                    <button
                        key={i}
                        className={`filter ${selectedCategory === sec.category ? "active" : ""}`}
                        onClick={() => setSelectedCategory(sec.category)}
                    >
                        {sec.category}
                    </button>
                ))}
            </div>

            <div className="faq-list">
                {filteredFaqs.map((section, sIdx) =>
                    section.questions.map((q, qIdx) => {
                        const index = `${section.category}-${qIdx}`;
                        const isOpen = openIndex === index;
                        return (
                            <div className={`faq-item ${isOpen ? 'open' : ''}`} key={index}>
                                <div className="faq-question" onClick={() => toggleQuestion(index)}>
                                    <span
                                        className="faq-category-label"
                                        style={{ color: section.color, borderColor: section.color }}
                                    >
                                        {section.category}
                                    </span>
                                    <span className="faq-question-text">{q}</span>
                                    <span className={`arrow ${isOpen ? 'open' : ''}`}>&#9660;</span>
                                </div>
                                {isOpen && (
                                    <div className="faq-answer">
                                        <p>{section.answers[qIdx]}</p>
                                        {qIdx === section.questions.length - 1 && (
                                            <div className="faq-end-message">
                                                더 궁금한 점이 있다면 고객센터로 문의해주세요.
                                            </div>
                                        )}
                                    </div>
                                )}
                            </div>
                        );
                    })
                )}
            </div>
        </div>
    );
};

export default FAQPage;
